import { render } from "./TripSheetDashboard.vue?vue&type=template&id=2ce984f0&scoped=true"
import script from "./TripSheetDashboard.vue?vue&type=script&lang=js"
export * from "./TripSheetDashboard.vue?vue&type=script&lang=js"

import "./TripSheetDashboard.vue?vue&type=style&index=0&id=2ce984f0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\blake\\LREX-site\\lrex-site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ce984f0"]])

export default __exports__